export default {
  namespaced: true,

  state: () => ({
    selectMode: false,
    sortMode: '',
    checkedFolders: [],
    checkedPodcasts: [],
    currentFolder: null,
  }),

  mutations: {
    toggleSelectMode(state) {
      state.selectMode = !state.selectMode

      if (!state.selectMode) {
        state.checkedFolders = []
        state.checkedPodcasts = []
      }
    },
    disableSelectMode(state) {
      state.selectMode = false
      state.checkedFolders = []
      state.checkedPodcasts = []
    },
    setSortMode(state, mode) {
      state.sortMode = mode
    },
    toggleFolder(state, item) {
      const index = state.checkedFolders.findIndex(i => i === item)
      if (index >= 0) {
        state.checkedFolders.splice(index, 1)
      } else {
        state.checkedFolders.push(item)
      }
    },
    togglePodcast(state, item) {
      const index = state.checkedPodcasts.findIndex(i => i === item)
      if (index >= 0) {
        state.checkedPodcasts.splice(index, 1)
      } else {
        state.checkedPodcasts.push(item)
      }
    },
    addFolder(state, item) {
      const index = state.checkedFolders.findIndex(i => i === item)
      if (index < 0) {
        state.checkedFolders.push(item)
      }
    },
    removeFolder(state, item) {
      const index = state.checkedFolders.findIndex(i => i === item)
      if (index >= 0) {
        state.checkedFolders.splice(index, 1)
      }
    },
    addPodcast(state, item) {
      const index = state.checkedPodcasts.findIndex(i => i === item)
      if (index < 0) {
        state.checkedPodcasts.push(item)
      }
    },
    removePodcast(state, item) {
      const index = state.checkedPodcasts.findIndex(i => i === item)
      if (index >= 0) {
        state.checkedPodcasts.splice(index, 1)
      }
    },
    setCurrentFolder(state, folder) {
      state.currentFolder = folder
    },
  },
}
